/**
 * Utilities: Array
 *
 * @module utility/UArray
 * @example import { UArray } from '../common/utility/u-array';
 */


// ƒ
// ============================================================================

/**
 * Get an array count safely. Checks that the supplied var is valid (ie. exists
 * and is an array)
 *
 * @param   {mixed}  $arr  Input array (can be any type of value)
 *
 * @return  {int}        Array length, or 0 if the array is empty, or the supplied var is invalid
 */
function safeArrayCount( $arr = null )
{
	return ( $arr && Array.isArray( $arr ) && $arr.length ) ? $arr.length : 0;
}


// Exports
// ============================================================================

export const UArray = { safeArrayCount };